/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createPlatform = /* GraphQL */ `
  mutation CreatePlatform(
    $input: CreatePlatformInput!
    $condition: ModelPlatformConditionInput
  ) {
    createPlatform(input: $input, condition: $condition) {
      id
      name
      description
      image {
        bucket
        region
        key
      }
      categories {
        items {
          id
          order
          name
          description
          platformId
          multipleCategoryUnits
          optional
          categoryUnits {
            items {
              id
              order
              name
              description
              developerDays
              graphicsDays
              categoryId
              image {
                bucket
                region
                key
              }
            }
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const updatePlatform = /* GraphQL */ `
  mutation UpdatePlatform(
    $input: UpdatePlatformInput!
    $condition: ModelPlatformConditionInput
  ) {
    updatePlatform(input: $input, condition: $condition) {
      id
      name
      description
      image {
        bucket
        region
        key
      }
      categories {
        items {
          id
          order
          name
          description
          platformId
          multipleCategoryUnits
          optional
          categoryUnits {
            items {
              id
              order
              name
              description
              developerDays
              graphicsDays
              categoryId
              image {
                bucket
                region
                key
              }
            }
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const deletePlatform = /* GraphQL */ `
  mutation DeletePlatform(
    $input: DeletePlatformInput!
    $condition: ModelPlatformConditionInput
  ) {
    deletePlatform(input: $input, condition: $condition) {
      id
      name
      description
      image {
        bucket
        region
        key
      }
      categories {
        items {
          id
          order
          name
          description
          platformId
          multipleCategoryUnits
          optional
          categoryUnits {
            items {
              id
              order
              name
              description
              developerDays
              graphicsDays
              categoryId
              image {
                bucket
                region
                key
              }
            }
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      order
      name
      description
      platformId
      multipleCategoryUnits
      optional
      categoryUnits {
        items {
          id
          order
          name
          description
          developerDays
          graphicsDays
          categoryId
          image {
            bucket
            region
            key
          }
        }
        nextToken
      }
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      order
      name
      description
      platformId
      multipleCategoryUnits
      optional
      categoryUnits {
        items {
          id
          order
          name
          description
          developerDays
          graphicsDays
          categoryId
          image {
            bucket
            region
            key
          }
        }
        nextToken
      }
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      order
      name
      description
      platformId
      multipleCategoryUnits
      optional
      categoryUnits {
        items {
          id
          order
          name
          description
          developerDays
          graphicsDays
          categoryId
          image {
            bucket
            region
            key
          }
        }
        nextToken
      }
    }
  }
`;
export const createCategoryUnit = /* GraphQL */ `
  mutation CreateCategoryUnit(
    $input: CreateCategoryUnitInput!
    $condition: ModelCategoryUnitConditionInput
  ) {
    createCategoryUnit(input: $input, condition: $condition) {
      id
      order
      name
      description
      developerDays
      graphicsDays
      categoryId
      image {
        bucket
        region
        key
      }
    }
  }
`;
export const updateCategoryUnit = /* GraphQL */ `
  mutation UpdateCategoryUnit(
    $input: UpdateCategoryUnitInput!
    $condition: ModelCategoryUnitConditionInput
  ) {
    updateCategoryUnit(input: $input, condition: $condition) {
      id
      order
      name
      description
      developerDays
      graphicsDays
      categoryId
      image {
        bucket
        region
        key
      }
    }
  }
`;
export const deleteCategoryUnit = /* GraphQL */ `
  mutation DeleteCategoryUnit(
    $input: DeleteCategoryUnitInput!
    $condition: ModelCategoryUnitConditionInput
  ) {
    deleteCategoryUnit(input: $input, condition: $condition) {
      id
      order
      name
      description
      developerDays
      graphicsDays
      categoryId
      image {
        bucket
        region
        key
      }
    }
  }
`;
export const createConfiguration = /* GraphQL */ `
  mutation CreateConfiguration(
    $input: CreateConfigurationInput!
    $condition: ModelConfigurationConditionInput
  ) {
    createConfiguration(input: $input, condition: $condition) {
      id
      developerRate
      graphicsRate
      configurationId
    }
  }
`;
export const updateConfiguration = /* GraphQL */ `
  mutation UpdateConfiguration(
    $input: UpdateConfigurationInput!
    $condition: ModelConfigurationConditionInput
  ) {
    updateConfiguration(input: $input, condition: $condition) {
      id
      developerRate
      graphicsRate
      configurationId
    }
  }
`;
export const deleteConfiguration = /* GraphQL */ `
  mutation DeleteConfiguration(
    $input: DeleteConfigurationInput!
    $condition: ModelConfigurationConditionInput
  ) {
    deleteConfiguration(input: $input, condition: $condition) {
      id
      developerRate
      graphicsRate
      configurationId
    }
  }
`;
export const updateEstimation = /* GraphQL */ `
  mutation UpdateEstimation(
    $input: UpdateEstimationInput!
    $condition: ModelEstimationConditionInput
  ) {
    updateEstimation(input: $input, condition: $condition) {
      id
      email
      platform
      configs
      cost
      createdAt
      updatedAt
    }
  }
`;
export const deleteEstimation = /* GraphQL */ `
  mutation DeleteEstimation(
    $input: DeleteEstimationInput!
    $condition: ModelEstimationConditionInput
  ) {
    deleteEstimation(input: $input, condition: $condition) {
      id
      email
      platform
      configs
      cost
      createdAt
      updatedAt
    }
  }
`;
export const createEstimation = /* GraphQL */ `
  mutation CreateEstimation(
    $input: CreateEstimationInput!
    $condition: ModelEstimationConditionInput
  ) {
    createEstimation(input: $input, condition: $condition) {
      id
      email
      platform
      configs
      cost
      createdAt
      updatedAt
    }
  }
`;
